import React from 'react';
import Seo from './Seo';
import SectionTitle from './SectionTitle';

function Mentions() {
  return (
    <div className='mentions container'>
      <Seo
        path="/mentions-legales"
        title="Mentions légales"
        description="Mentions légales du site du Tennis de Table Briançon : éditeur, hébergeur, propriété intellectuelle, données personnelles et cookies."
        noindex
      />

      <SectionTitle as="h1" overline="Informations">Mentions légales</SectionTitle>

      <section>
        <h2>Éditeur du site</h2>
        <p>
          Le présent site est édité par l'association <strong>Tennis de Table Briançon</strong>,
          club de tennis de table affilié à la Fédération Française de Tennis de Table (FFTT),
          représentée par sa présidente ou son président en exercice.
        </p>
        <p>
          Adresse : Vieux gymnase des Garcins, Albert Bourges, 05100 Briançon, France<br />
          Contact : <a href="mailto:contact@ttbriancon.fr">contact@ttbriancon.fr</a>
        </p>
        <p>
          Responsable de la publication : le bureau de l'association.
        </p>
      </section>

      <section>
        <h2>Conception et développement</h2>
        <p>
          Site conçu et développé par William Bonjour — <a href="mailto:williambonjour05@gmail.com">williambonjour05@gmail.com</a>.
        </p>
      </section>

      <section>
        <h2>Hébergement</h2>
        <p>
          OVH SAS — 2 rue Kellermann, 59100 Roubaix, France — <a href="https://www.ovh.com" target="_blank" rel="noopener noreferrer">www.ovh.com</a>.
        </p>
      </section>

      <section>
        <h2>Propriété intellectuelle</h2>
        <p>
          Les textes, la charte graphique, le logo et les photographies présents sur ce site sont
          la propriété de l'association Tennis de Table Briançon ou de leurs auteurs respectifs.
          Toute reproduction, représentation, adaptation ou diffusion, totale ou partielle, sans
          autorisation écrite préalable, est interdite.
        </p>
        <p>
          Les résultats, classements et calendriers de rencontres sont issus des données publiques
          de la Fédération Française de Tennis de Table.
        </p>
      </section>

      <section>
        <h2>Données personnelles</h2>
        <p>
          Le formulaire de contact recueille votre nom, votre prénom, votre adresse e-mail et
          votre message. Ces informations sont transmises par courrier électronique aux
          responsables du club, via le service d'envoi EmailJS, dans le seul but de traiter votre
          demande. Elles ne sont pas conservées au-delà du temps nécessaire à cet échange, ne sont
          jamais cédées à des tiers et ne servent à aucune prospection.
        </p>
        <p>
          Le site ne crée aucun compte utilisateur et n'utilise pas d'outil de mesure d'audience.
        </p>
        <p>
          Conformément au Règlement général sur la protection des données (RGPD) et à la loi
          « Informatique et Libertés », vous disposez d'un droit d'accès, de rectification et de
          suppression des données vous concernant. Pour l'exercer, écrivez à <a href="mailto:contact@ttbriancon.fr">contact@ttbriancon.fr</a>.
          Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).
        </p>
      </section>

      <section>
        <h2>Cookies et services tiers</h2>
        <p>
          Le site ne dépose aucun cookie publicitaire ni de mesure d'audience. Certains services
          tiers nécessaires à son fonctionnement peuvent toutefois déposer des cookies ou recevoir
          des données techniques :
        </p>
        <ul>
          <li>
            <strong>Google reCAPTCHA</strong> protège le formulaire de contact contre les envois
            automatisés ; ce service dépose des cookies et traite des données selon la politique de
            confidentialité et les conditions d'utilisation de Google.
          </li>
          <li>
            <strong>OpenStreetMap</strong> fournit le fond de carte de la page d'accueil ;
            son affichage entraîne des requêtes (dont votre adresse IP) vers les serveurs
            d'OpenStreetMap.
          </li>
          <li>
            <strong>Facebook / Meta</strong> : les dernières publications de la page du club sont
            récupérées via l'API de Meta et affichées sous forme de vignettes. Aucun script de
            suivi Facebook n'est chargé sur le site.
          </li>
        </ul>
      </section>

      <section>
        <h2>Liens externes</h2>
        <p>
          Ce site contient des liens vers des sites tiers (Fédération Française de Tennis de Table,
          partenaires, page Facebook du club). L'association Tennis de Table Briançon n'exerce
          aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
        </p>
      </section>

      <section>
        <h2>Responsabilité</h2>
        <p>
          Les informations publiées sont aussi précises que possible et le site est mis à jour
          régulièrement, mais il peut néanmoins contenir des inexactitudes ou des omissions. Si
          vous constatez une erreur ou un dysfonctionnement, merci de le signaler par e-mail à <a href="mailto:contact@ttbriancon.fr">contact@ttbriancon.fr</a>.
        </p>
      </section>

      <section>
        <h2>Droit applicable</h2>
        <p>Le présent site et ses mentions légales sont soumis au droit français.</p>
      </section>
    </div>
  );
}

export default Mentions;
